import { FormLayout, Modal, Text, TextField } from '@shopify/polaris';
import { lengthLessThan, lengthMoreThan, notEmptyString, useField, useForm } from '@shopify/react-form';
import { useNotification } from 'context/NotificationContext';
import helpers from 'helpers/index';
import { useMutateRefund } from 'queries/transactions.query';
import { useCallback } from 'react';

export default function RefundModal({ show, transactionsID, onClose }: { show: boolean; transactionsID: string[]; onClose: () => void }) {
  const { mutateAsync: refundFn, isPending } = useMutateRefund();
  const { addNotification } = useNotification();
  const refundNote = useField<string>({
    value: '',
    validates: [
      notEmptyString('Trường này không được để trống.'),
      lengthMoreThan(10, 'Không đủ chi tiết cho giao dịch.'),
      lengthLessThan(500, 'Bạn điền quá dài!'),
    ],
  });

  const { fields, submit, reset } = useForm({
    fields: { refund_note: refundNote },
    async onSubmit(form) {
      try {
        await refundFn({ refund_note: form.refund_note, transaction_id: transactionsID });
        closeRefundModal();
        addNotification('info', 'Hoàn tiền thành công!');
      } catch (e) {}
      return { status: 'success' };
    },
  });

  const closeRefundModal = useCallback(() => {
    helpers.cleanEntity({ refund_note: refundNote });
    reset();
    onClose();
  }, [onClose, refundNote, reset]);

  return (
    <Modal
      open={show}
      onClose={closeRefundModal}
      title="Hoàn tiền giao dịch"
      primaryAction={{
        content: 'Xác nhận hoàn tiền',
        disabled: isPending,
        loading: isPending,
        onAction: submit,
      }}
      secondaryActions={[{ content: 'Hủy', onAction: closeRefundModal }]}
    >
      <Modal.Section>
        <FormLayout>
          <Text as="p">Các giao dịch đã chọn: {transactionsID.join(', ') || '--'}</Text>
          <TextField
            label="Ghi chú hoàn tiền"
            multiline={4}
            autoComplete="off"
            requiredIndicator
            placeholder="Nhập lý do hoặc thông tin hoàn tiền"
            helpText="Giao dịch sẽ được hoàn lại theo đúng phương thức thanh toán ban đầu."
            {...fields.refund_note}
          />
        </FormLayout>
      </Modal.Section>
    </Modal>
  );
}
